import React, { useEffect, useRef, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import triangle from "../../images/triangle.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Select from "react-select";
import moment from "moment";
import Toastify from "../common/Toastify";
import DeleteItemModal from "../../modal/DeleteItemModal";
import { DELETEREQUEST, GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import { addTrailingZeros, formatPrice } from "../helpers/common";
import { generateCrateCreditPdf } from "../Pdfs/CrateCredit";

const ViewEditCrateCredit = () => {
    const { id } = useParams();
    const { user } = useAuth();

    const navigate = useNavigate();
    const creditDetailObj = {
        Qty: '',
        ContainerID: '',
        CrateCreditAmt: '',
        CrateReturnValue: '',
        CrateReturnGST: 0
    }
    const [errors, setErrors] = useState({});
    const [creditDetails, setCreditDetails] = useState([creditDetailObj]);
    const [crates, setCrates] = useState([]);
    const [customerDetailsObj, setCustomerDetailsObj] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [returnDate, setReturnDate] = useState(moment().format('YYYY-MM-DD'));
    const [reference, setReference] = useState('0');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [ShowDeleteCreditModal, setShowDeleteCreditModal] = useState(false);

    useEffect(() => {
        var headerHeight = $("header").outerHeight();
        var mainHeight = $(window).height() - headerHeight;
        $("main").height(mainHeight);
        $("main").css("margin-top", headerHeight + "px");

        var tableRow = ".table-form thead > tr";

        $(tableRow).on("focusin", function () {
            $(this).addClass("focus-tr");
        });

        $(tableRow).on("focusout", function () {
            $(this).removeClass("focus-tr");
        });
    });

    useEffect(() => {
        const fetchData = async () => {
            if (id) {
                let URL = process.env.REACT_APP_API_URL + `/get-crate-credit/${id} `;
                let response = await GETREQUEST(URL, user.jwtToken);
                if (response?.data) {
                    let creditData = response.data?.credit;
                    let containersData = response.data?.containers;
                    setCustomerDetailsObj(creditData.tblCustomer);
                    setReference(creditData.CNReference);
                    setReturnDate(moment(creditData.CNDate).format('YYYY-MM-DD'));
                    setCreditDetails(prevCrateDetails => {
                        const updatedCrateDetails = [...creditData.tblCrateCreditDetails, creditDetailObj];
                        return updatedCrateDetails;
                    });

                    let containersList = [];
                    containersData?.forEach((item) => {
                        containersList = [...containersList, { label: item.TypeInCode, value: item.ContainerID, ...item }];
                    });

                    containersList.sort((a, b) => {
                        const numA = parseInt(a.label);
                        const numB = parseInt(b.label);

                        if (!isNaN(numA) && !isNaN(numB)) {
                            return numA - numB;
                        } else if (!isNaN(numA)) {
                            return -1;
                        } else if (!isNaN(numB)) {
                            return 1;
                        } else {
                            return a.TypeInCode.localeCompare(b.TypeInCode);
                        }
                    });
                    setCrates(containersList)
                }
            }
        }
        fetchData();
    }, [id])

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: "gray",
            backgroundColor: state.isSelected ? "#01B1E3" : "#fff",
            zIndex: 9999,
        }),
    };

    const CustomOption = (props) => {
        return (
            <div
                className=""
                style={{
                    background: props.isFocused
                        ? '#01B1E3'
                        : props.isSelected
                            ? 'rgb(54, 179, 126)'
                            : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
                }}
                {...props.innerProps}
                ref={props.innerRef}
            >
                {props.label}
            </div>
        )
    }

    const calculateTotalCredit = () => {
        let total = 0;
        creditDetails.map((credit) => {
            let value = credit.CrateCreditAmt;
            if (value)
                total += parseFloat(value);
        });
        return total ? total.toFixed(2) : 0.00
    }

    const addNewRow = (e, index) => {
        if (Object.keys(errors).length > 0) {
            e.preventDefault();
        }
        else if (creditDetails.length - 1 == index) {
            setCreditDetails(prevCrateDetails => {
                const updatedCrateDetails = [...prevCrateDetails, creditDetailObj];
                return updatedCrateDetails;
            });
        }
    }

    const handleRowDelete = (index) => {
        let creditD = creditDetails.filter((a, i) => index !== i);
        setCreditDetails(creditD);
    };

    const handleCrateChange = (e, index) => {
        let CrateCreditAmt = creditDetails[index].Qty * e.ReturnValue;
        setCreditDetails(prevCrateDetails => {
            const updatedCrateDetails = [...prevCrateDetails];
            updatedCrateDetails[index].ContainerID = e.value;
            updatedCrateDetails[index].CrateCreditAmt = addTrailingZeros(CrateCreditAmt);
            updatedCrateDetails[index].CrateReturnValue = e.ReturnValue;
            return updatedCrateDetails;
        });
    }

    const handlePreview = () => {
        let updatedCrateDetails = [];
        creditDetails.map((creditItem) => {
            if (creditItem.Qty !== '' && creditItem.ContainerID !== '' && creditItem.CrateReturnValue !== '') {
                updatedCrateDetails.push({
                    ...creditItem,
                    CrateCreditAmt: creditItem.CrateCreditAmt ? parseFloat(creditItem.CrateCreditAmt).toFixed(2) : 0
                })
            }
        })
        let previewData = {
            CNID: id,
            ReturnDate: returnDate,
            ReferenceNo: reference,
            tblCustomer: customerDetailsObj,
            crates,
            creditDetails: updatedCrateDetails
        }
        generateCrateCreditPdf(previewData);
    }

    const handleUpdate = async () => {
        let updatedCrateDetails = [];
        creditDetails.map((creditItem) => {
            if (creditItem.Qty !== '' && creditItem.ContainerID !== '' && creditItem.CrateReturnValue !== '') {
                updatedCrateDetails.push({
                    ...creditItem,
                    CrateCreditAmt: creditItem.CrateCreditAmt ? parseFloat(creditItem.CrateCreditAmt).toFixed(2) : 0
                })
            }
        })
        let payload = {
            CNID: id,
            CustomerID: customerDetailsObj?.CustomerID,
            ReturnDate: returnDate,
            ReferenceNo: reference,
            creditDetails: updatedCrateDetails
        }
        let updateURL = process.env.REACT_APP_API_URL + "/update-crate-credit";
        setMessage('');
        setMessageType('');
        let response = await POSTREQUEST(updateURL, payload, user.jwtToken);
        if (response?.data) {
            if (response.data.success) {
                setMessage(response.data.message);
                setMessageType('success');
            } else {
                setMessage(response.data.message);
                setMessageType('error');
            }
        } else {
            setMessage(response?.error?.message || 'Failed to update crate credit !!');
            setMessageType('error');
        }
    }

    const handleDelete = async () => {
        setShowDeleteCreditModal(false);
        let URL = `${process.env.REACT_APP_API_URL}/delete-crate-credit/${id}`;
        let response = await DELETEREQUEST(URL, user.jwtToken);
        if (response?.data) {
            setMessageType('')
            setMessage('')
            if (response.data.success) {
                setMessage(response.data.message);
                setMessageType('success');
                setTimeout(() => {
                    navigate("/all-crate-credits");
                }, 2000);
            } else {
                setMessage(response.data.message);
                setMessageType('error');
            }
        } else {
            setMessage(response?.error?.message || 'Failed to delete product !!');
            setMessageType('error');
        }
    }

    return (
        <React.Fragment>
            {ShowDeleteCreditModal && <DeleteItemModal modal={ShowDeleteCreditModal} handleDelete={handleDelete} setModal={setShowDeleteCreditModal} title={"Delete Crate Credit ?"} text={"Do you want to delete this Crate Credit ?"} />}
            <Header />
            {message && <Toastify message={message} type={messageType} />}
            <main className="bg-lite-grey overflow-auto">
                <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
                    <div className="table-elements">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item fs-15">
                                    <Link
                                        to="/all-crate-credits"
                                        className="text-decoration-none text-primary"
                                    >
                                        Crate Credits
                                    </Link>
                                </li>
                                <li
                                    className="breadcrumb-item fs-15 active"
                                    aria-current="page"
                                >
                                    View/Edit
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="card border-bottom-0">
                        <div className="card-header bg-white d-flex align-items-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap overflow-auto">
                            <h1 className="title-semibold fs-24 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                                View/Edit Crate Credit
                            </h1>
                        </div>
                        <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 flex-nowrap">
                            <div className="custom-group flex-nowrap">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Code:
                                </label>
                                <div className="date position-relative cme-15">
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        placeholder="Code"
                                        defaultValue={customerDetailsObj?.CustomerCode}
                                        style={{ width: "100px" }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="custom-group flex-nowrap">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Customer:
                                </label>
                                <div className="date position-relative cme-15">
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        placeholder="Customer"
                                        defaultValue={customerDetailsObj?.CustomerName}
                                        style={{ width: "360px" }}
                                        disabled
                                    />
                                </div>
                            </div>

                            <div className="custom-group flex-nowrap mb-lg-0">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Return date:
                                </label>
                                <div className="position-relative cme-12" data-provide="datepicker">
                                    <input
                                        type="date"
                                        id="datepicker"
                                        className="form-control input-sm date input-datepicker"
                                        placeholder="Select Date"
                                        value={returnDate}
                                        onChange={(e) => {
                                            setReturnDate(e.target.value);
                                        }}
                                    />
                                </div>

                            </div>

                            <div className="custom-group flex-nowrap mb-lg-0 pe-3">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Credit No:
                                </label>
                                <input
                                    type="text"
                                    className={`form-control input-sm input-width-180`}
                                    defaultValue={id}
                                    disabled
                                />
                            </div>


                            <div className="custom-group flex-nowrap">
                                <label
                                    htmlFor=""
                                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                                >
                                    Reference:
                                </label>
                                <div className="date position-relative cme-15">
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        value={reference}
                                        style={{ width: "100px" }}
                                        onChange={(e) => setReference(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-4 border-bottom">
                            <div className="card-table table-responsive">
                                <table className="table table-form disable-field">
                                    <thead>
                                        <tr>
                                            <td scope="col" className="width-lg-1"></td>
                                            <td scope="col" className="width-lg-4">
                                                Qty
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Crate
                                            </td>
                                            <td scope="col" className="width-lg-6">
                                                Crate Credit
                                            </td>
                                            <td scope="col" className="width-lg-1"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {creditDetails.length > 0 && creditDetails.map((creditDetailItem, index) => {
                                            return (<tr key={index + 1} className="custom-space">
                                                <td valign="middle">
                                                    <img src={triangle} className="indicator" alt="" />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className={`form-control input-sm text-end input-width-90 ${errors[`Qty` + index] ? "is-invalid" : ''} `}
                                                        placeholder="Qty"
                                                        onChange={(e) => {
                                                            setCreditDetails(prevCrateDetails => {
                                                                const updatedCrateDetails = [...prevCrateDetails];
                                                                updatedCrateDetails[index].Qty = e.target.value;
                                                                updatedCrateDetails[index].CrateCreditAmt = e.target.value * (crates.find(crate => crate.ContainerID == updatedCrateDetails[index].ContainerID))?.ReturnValue;
                                                                return updatedCrateDetails;
                                                            });
                                                        }}
                                                        value={creditDetailItem.Qty}
                                                    // onBlur={(e) => checkError(e.target.value, index, 'Qty')}
                                                    />
                                                </td>
                                                <td>
                                                    <Select
                                                        className="input-sm input-width-90"
                                                        defaultValue={"Select Crate"}
                                                        value={crates.find(crate => crate.ContainerID == creditDetailItem.ContainerID) || ''}
                                                        options={crates}
                                                        placeholder="Select Crate"
                                                        onChange={(e) => handleCrateChange(e, index)}
                                                        components={{ Option: CustomOption }}
                                                    ></Select>
                                                </td>
                                                <td>
                                                    <div className="position-relative input-icon">
                                                        <input
                                                            type="text"
                                                            className="form-control input-sm text-end ps-4 input-width-110"
                                                            value={creditDetailItem.CrateCreditAmt || "0.00"}
                                                            onChange={(e) => {
                                                                setCreditDetails(prevCrateDetails => {
                                                                    const updatedCrateDetails = [...prevCrateDetails];
                                                                    updatedCrateDetails[index].CrateCreditAmt = formatPrice(e.target.value);
                                                                    return updatedCrateDetails;
                                                                });
                                                            }}
                                                            onBlur={(e) => {
                                                                setCreditDetails(prevCrateDetails => {
                                                                    const updatedCrateDetails = [...prevCrateDetails];
                                                                    updatedCrateDetails[index].CrateCreditAmt = addTrailingZeros(e.target.value);
                                                                    return updatedCrateDetails;
                                                                });
                                                                addNewRow(e, index)}}
                                                        />
                                                        <span className="text-lite cps-10 fs-14">$</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-inline-flex align-items-center justify-content-end flex-grow-1">
                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleRowDelete(index)}
                                                            className={`text - decoration - none ${creditDetails.length - 1 === index ? 'd-none' : ''} `}
                                                        >
                                                            <i className="icon icon-delete ms-3 text-danger fw-bold"></i>
                                                        </div>
                                                    </div>
                                                </td>

                                            </tr>)
                                        })}
                                    </tbody>

                                </table>

                            </div>
                            {!message && <div className="text-center"><span className='text-danger'>Kindly Save the Data before Exit Otherwise Data will be lost</span></div>}
                            <div className="row d-flex justify-content-between align-items-end mt-2 mt-lg-0 pb-3">
                                <div className="col-md-2 d-flex">
                                    <label className="p-1">
                                        Items:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control input-sm text-end ps-4"
                                        //  value={creditDetails.length - 1}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2 d-flex">
                                    <label className="p-1">
                                        Total:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control input-sm text-end ps-4"
                                        value={calculateTotalCredit()}
                                        readOnly
                                    />
                                </div>
                            </div>

                            <div className="col d-flex justify-content-between align-items-end mt-4 mt-lg-0">
                                <div className="d-flex">
                                    <button type="button"
                                        role="button"
                                        className="btn btn-md btn-outline-danger d-flex align-items-center px-4 fw-medium rounded-3 mx-1 text-nowrap"
                                        onClick={() => setShowDeleteCreditModal(true)}
                                    >
                                        Delete Credit Note
                                    </button>
                                </div>
                                <div className="d-flex">
                                    <button
                                        onClick={handlePreview}
                                        type="button"
                                        className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    >
                                        Preview
                                    </button>
                                    <button type="button"
                                        onClick={handleUpdate}
                                        //disabled={creditDetails.length === 1}
                                        className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                                    >
                                        Update Credit Note
                                    </button>
                                    <button type="button"
                                        onClick={() => { navigate("/all-crate-credits") }}
                                        className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                                    >
                                        Exit
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>
            </main>
        </React.Fragment>
    )
}

export default ViewEditCrateCredit
